export const getPublicIP = (() => {
  const SESSION_STORAGE_KEY = 'identityClientI';

  // Definimos los servicios con una función para extraer la IP según su formato
  const services = [
    {
      url: 'https://ip.guide',
      extract: async (res) => (await res.json()).ip
    },
    {
      url: 'https://icanhazip.com/',
      extract: async (res) => (await res.text()).trim()
    }
  ];

  const fetchIP = async (service) => {
    const response = await fetch(service.url);
    if (!response.ok) throw new Error(`Error en ${service.url}`);

    const ip = await service.extract(response);

    // Validación de formato IP básico
    if (!/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(ip)) {
      throw new Error("Formato de IP inválido");
    }
    return ip;
  };

  return async () => {
    // 1. Intentar obtener de sessionStorage
    const storedEncoded = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (storedEncoded) {
      try {
        return atob(storedEncoded);
      } catch (e) {
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
      }
    }

    // 2. Ejecutar ambos servicios en paralelo
    try {
      const fastestIP = await Promise.any(services.map(s => fetchIP(s)));

      // 3. Guardar en Base64 y retornar
      sessionStorage.setItem(SESSION_STORAGE_KEY, btoa(fastestIP));
      return fastestIP;
    } catch (error) {
      console.error('Ambos servicios de IP fallaron', error);
      throw new Error('No se pudo obtener la IP pública');
    }
  };
})();